import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Helmet } from 'react-helmet-async';

import GenericMeta from '../GenericMeta';

const SEODescription = ({ content }) => {
  const renderMeta = (description) => {
    const text =
      typeof description === 'string' ? description : String(description);
    return (
      <>
        <Helmet>
          <meta name="description" content={text} />
        </Helmet>
        <GenericMeta property="og:description" content={text} />
        <GenericMeta name="twitter:description" content={text} />
      </>
    );
  };

  const isMessageDescriptor =
    content && typeof content === 'object' && content.id;
  return isMessageDescriptor ? (
    <FormattedMessage {...content}>{renderMeta}</FormattedMessage>
  ) : (
    renderMeta(content)
  );
};

SEODescription.propTypes = {
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
};

export default SEODescription;
